import React from "react";
import ReactDOM from "react-dom";
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import "assets/css/App.css";
import "mapbox-gl/dist/mapbox-gl.css";
import {BrowserRouter, Route, Switch, Redirect} from "react-router-dom";
import AuthLayout from "layouts/auth";
import OptimizeLayout from "./layouts/optimize";
import * as FullStory from '@fullstory/browser';

// import { BrowserRouter } from "react-router-dom";
// Chakra imports
import {ChakraProvider} from "@chakra-ui/react";
import theme from "theme/theme";
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache} from "@apollo/client";
import {setContext} from '@apollo/client/link/context';
import Cookies from 'universal-cookie';
import AnalysisLayout from "./layouts/home";

FullStory.init({orgId: 'o-1EFATZ-na1'});
console.log("process.env.HASURA_GRAPHQL_API", process.env.REACT_APP_HASURA_GRAPHQL_API);
const authLink = setContext((_, {headers}) => {
    // get the authentication token from cookies if it exists
    const cookies = new Cookies();
    const jwtToken = cookies.get('jwtToken');
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: jwtToken ? `Bearer ${jwtToken}` : "",
        }
    }
});
const gqlClient = new ApolloClient({
    link: authLink.concat(new HttpLink({
            uri: process.env.REACT_APP_HASURA_GRAPHQL_API,
            //headers: {'x-hasura-admin-secret': process.env.REACT_APP_HASURA_GRAPHQL_ADMIN_SECRET}
        }
    )),
    cache: new InMemoryCache({
        typePolicies: {
            customer_brands_to_products: {
                keyFields: ["product_platform_id"],
            },
        }
    }),
});
console.log('gqlClient', gqlClient);

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCn18RER0SvwqioL1pe1O_OME5MdJyvYEA",
    authDomain: "omega-dahlia-366205.firebaseapp.com",
    projectId: "omega-dahlia-366205",
    storageBucket: "omega-dahlia-366205.appspot.com",
    messagingSenderId: "842893882889",
    appId: "1:842893882889:web:842e659c7c86dbecea2ad8",
    measurementId: "G-6T9Q8X2PD4",
    databaseURL: "https://omega-dahlia-366205-default-rtdb.firebaseio.com/"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

ReactDOM.render(
    <ApolloProvider client={gqlClient}>
        <ChakraProvider theme={theme}>
            <React.StrictMode>
                <BrowserRouter>
                    <Switch>
                        <Route path={`/auth`} component={AuthLayout}/>
                        {/*<Route path={`/admin`} component={AdminLayout}/> {/*DEPRECATE THIS ROUTE*/} */}
                        <Route path={'/home'} component={AnalysisLayout}/>
                        {/*<Route path={'/themes'} component={ThemesLayout}/>*/}
                        <Route path={'/optimize'} component={OptimizeLayout}/>
                        <Redirect from='/' to='/home'/>
                    </Switch>
                </BrowserRouter>
            </React.StrictMode>
        </ChakraProvider>
    </ApolloProvider>,
    document.getElementById("root")
);
